import { Fragment } from 'react';
import { NJText } from '@engie-group/fluid-design-system-react';
import { UMR } from '../../urbanmap/_components';
import type { Project } from './types';
import { Tag } from './ui';

/** Paramètres du projet : « certain / réalité », lecture seule. */
export function ParamsTab({ project }: { project: Project }) {
  const q = project.params;
  const groups: { title: string; v2?: boolean; rows: [string, string][] }[] = [
    { title: 'Périmètre et réseau', rows: [['Périmètre', q.perimeter], ['Réseau existant (fichier)', q.existingNetwork], ['Existant ou nouveau', q.networkKind], ['Sélections importées', String(q.selectionsImported)]] },
    { title: 'Météo et températures', rows: [['Station météo', q.weatherStation], ['DJU', String(q.dju)], ['Profil de température', q.temperatureProfile]] },
    { title: 'Consommations', rows: [['Ratios chaud', q.heatRatio], ['Ratios froid', q.coldRatio]] },
    { title: 'Dates et géométrie', rows: [['Début du projet', q.startDate], ['Fin du projet', q.endDate], ['Coefficient de surlongueur', String(q.detourCoef)], ['Routes manquantes', 'Ajout possible (sans pondération)']] },
  ];
  return (
    <div style={{ padding: 16 }}>
      <NJText as="h2" scale="lg" style={{ margin: '0 0 4px' }}>Paramètres du projet</NJText>
      <NJText scale="md" style={{ margin: '0 0 16px', color: UMR.textSecondary }}>Ce qui est certain : « Où et sur quoi je travaille ? ». Lecture seule ; valable pour tous les sets et plans.</NJText>
      {groups.map((g) => (
        <section key={g.title} style={{ marginBottom: 20 }}>
          <h3 style={{ margin: '0 0 8px', fontSize: 14, borderBottom: `1px solid ${UMR.border}`, paddingBottom: 6 }}>{g.title} {g.v2 && <Tag v2>V2</Tag>}</h3>
          <dl style={{ margin: 0, display: 'grid', gridTemplateColumns: '150px 1fr', gap: '6px 16px', fontSize: 14 }}>
            {g.rows.map(([k, v]) => <Fragment key={k}><dt style={{ color: UMR.textSecondary }}>{k}</dt><dd style={{ margin: 0 }}>{v}</dd></Fragment>)}
          </dl>
        </section>
      ))}
      <div style={{ fontSize: 12, color: UMR.textSecondary }}>Renommer, partager, dupliquer et supprimer le projet : <Tag v2>V2</Tag> hors périmètre du prototype.</div>
    </div>
  );
}
